// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Lb2F","title":"Images90_title__2icxp","images":"Images90_images__3HsHJ"};